/**
 * @generated SignedSource<<b5ab5855395366ca2c681e3590403cec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Scope = "ALL" | "DEFAULT" | "READ_COMPETITION" | "READ_PROJECT";
export type Oauth2AuthorizeInput = {
  clientId: string;
  redirectUri?: any | null | undefined;
  scope?: string | null | undefined;
  state?: string | null | undefined;
};
export type OAuth2AuthorizePageQuery$variables = {
  input: Oauth2AuthorizeInput;
};
export type OAuth2AuthorizePageQuery$data = {
  readonly oauth2Authorize: {
    readonly oauth2Config: {
      readonly description: string | null | undefined;
      readonly name: string;
    } | null | undefined;
    readonly redirectUri: any | null | undefined;
    readonly scope: ReadonlyArray<Scope>;
    readonly valid: boolean;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type OAuth2AuthorizePageQuery = {
  response: OAuth2AuthorizePageQuery$data;
  variables: OAuth2AuthorizePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scope",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectUri",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OAuth2AuthorizePageQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Oauth2PreGrant",
        "kind": "LinkedField",
        "name": "oauth2Authorize",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Oauth2Config",
            "kind": "LinkedField",
            "name": "oauth2Config",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OAuth2AuthorizePageQuery",
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Oauth2PreGrant",
        "kind": "LinkedField",
        "name": "oauth2Authorize",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Oauth2Config",
            "kind": "LinkedField",
            "name": "oauth2Config",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "909d871be9b80984fcb46c871f1aed24",
    "id": null,
    "metadata": {},
    "name": "OAuth2AuthorizePageQuery",
    "operationKind": "query",
    "text": "query OAuth2AuthorizePageQuery(\n  $input: Oauth2AuthorizeInput!\n) {\n  viewer @ifAllowed {\n    id\n  }\n  oauth2Authorize(input: $input) {\n    scope\n    oauth2Config {\n      name\n      description\n      id\n    }\n    redirectUri\n    valid\n  }\n}\n"
  }
};
})();

(node as any).hash = "c65f319425f258bb336895fc48197860";

export default node;
